import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Modal,
  TextField,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function ConfirmUpdateAccount({
  visible,
  onClose,
  onClickConfirm,
  membership
}) {
  const theme = useTheme();

  const [message, setMessage] = useState('');

  const onConfirm = () => {
    onClickConfirm(message);
    setMessage('');
  }

  return (
    <Modal
      open={visible}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '360px',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          padding: '32px 42px',
          '&:focus-visible': {
            outline: 'none',
          }
        }}
      >
        <Grid sx={{ width: '95%', margin: 'auto' }} className="text-center">
          <Grid container justifyContent='center' alignItems='center' className="swal-question swal-close" sx={{ borderColor: "#009ef7" }}>
            <Grid className="swal-x-content" sx={{ fontSize: '3em', color: '#009ef7' }}>?</Grid>
          </Grid>
          <Typography id="modal-modal-title" sx={{ fontSize: '1.8rem', fontWeight: 700, lineHeight: '1.2', mt: 2, textAlign: 'center' }}>
            {membership === 2 ? 'Cancel Account?' : 'Upgrade Account'}
          </Typography>
          <Typography id="modal-modal-description" sx={{ fontSize: '0.85rem', fontWeight: 400, mt: 1.5, textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#e0e0e0' }}>
            {membership === 2 ? 'A cancel request will be sent. We will need to verify your request before deleting your account and information permanently.' : 'Thank you for choosing Clientl. We will verify your upgrade request and an invoice will be sent to your email.'}
          </Typography>
          <TextField
            variant="standard"
            fullWidth
            multiline
            rows={3}
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder='Enter optional message here'
            InputProps={{
              disableUnderline: true,
              style: {
                padding: '15px 20px',
                borderRadius: '6px',
                fontSize: '0.8rem',
                fontWeight: 500,
              },
            }}
            sx={{ mt: 3 }}
          />
          <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
            <Button
              color="success"
              variant="contained"
              sx={{ fontSize: '0.9rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }}
              onClick={onConfirm}
            >
              Confirm
            </Button>
            <Button
              color="error"
              variant="contained"
              sx={{ marginInlineStart: 1, fontSize: '0.9rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
